import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Components
import Button from '@/main/components/shared/button/button';
import ContainerScreen from '@/main/components/shared/containerScreen/containerLayout';
import { getTranslateByKey } from '@/main/services/utils';
import * as S from './styles';
import { KogTabsComponent } from '@/main/components/shared/tabs/tabs';
import ImportHistoryTab from '../importHistory/importHistoryTab';
import PartsCatalogTab from '../partsCatalog/partsCatalogTab';
import { TabsInventoryProvider, useTabsInventoryContext } from './context';
import { RoutesConstants } from '@/main/routes/routesConstants';
import KogModalFadeComponent from '@/main/components/modal/ModalFadeComponent';
import ModalResultImport from './components/modalResultImport';

function ImportInventoryScreen() {
  const navigate = useNavigate();
  const [open, setOpen] = useState<boolean>(false);
  const [files, setFiles] = useState<File[]>([]);
  const [showFilters, setShowFilters] = useState<boolean>(true);
  // Context
  const {
    tabCurrent,
    setTabCurrent,
    searchGridHistory,
    gridData,
    setGridData,
    hasShowMore,
    setHasShowMore,
    gridDataEmpty,
    setGridDataEmpty,
    exporting,
    setExporting,
    uploading,
    setUploading,
    changeTab,
    dataReturnImport,
    openModalReturnImport,
    setOpenModalReturnImport,
    setDataReturnImport
  } = useTabsInventoryContext();

  // #region UseEffect's

  // Clear data return import when close modal
  useEffect(() => {
    if (!openModalReturnImport) {
      setDataReturnImport(null);
    }
  }, [openModalReturnImport]);
  // #endregion

  function handleFilters() {
    setShowFilters(!showFilters);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
  function handleAddNewPart(
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) {
    e.preventDefault();
    e.stopPropagation();
    navigate(RoutesConstants.inventoryRegister);
  }

  const tabPanels = [
    {
      tab: getTranslateByKey('information.filesHistory'),
      panel: (
        <ImportHistoryTab
          showFilters={showFilters}
          setShowFilters={setShowFilters}
          openModalImportInventory={open}
          closeModalImportInventory={closeModal}
          filesModalImportInventory={files}
          setFilesModalImportInventory={setFiles}
          setTabCurrent={setTabCurrent}
          gridData={gridData}
          setGridData={setGridData}
          hasShowMore={hasShowMore}
          setHasShowMore={setHasShowMore}
          searchGridHistory={searchGridHistory}
          gridDataEmpty={gridDataEmpty}
          setGridDataEmpty={setGridDataEmpty}
          exporting={exporting}
          setExporting={setExporting}
          uploading={uploading}
          setUploading={setUploading}
        />
      ),
      isShowControl: true
    },
    {
      tab: getTranslateByKey('information.partsCatalog'),
      panel: (
        <PartsCatalogTab
          showFilters={showFilters}
          setShowFilters={setShowFilters}
          openModalImportInventory={open}
          closeModalImportInventory={closeModal}
          filesModalImportInventory={files}
          setFilesModalImportInventory={setFiles}
          setTabCurrent={setTabCurrent}
          searchGridHistory={searchGridHistory}
          exporting={exporting}
          setExporting={setExporting}
          uploading={uploading}
          setUploading={setUploading}
        />
      ),
      isShowControl: true
    }
  ];

  function closeModal() {
    if (!exporting && !uploading) {
      setOpen(false);
    }
  }

  return (
    <ContainerScreen
      hasBackground
      title={`
      ${getTranslateByKey('module.inventory')}
      ${' > '}
      ${getTranslateByKey('screen.inventory')}`}>
      <S.Container>
        <S.AreaButton>
          <Button
            onClick={handleFilters}
            id="id-searchImportInventory-btn-filter">
            {getTranslateByKey('information.filters')}
          </Button>
          <Button
            onClick={handleAddNewPart}
            id="id-searchImportInventory-btn-addNewPart">
            {getTranslateByKey('information.addNewPart')}
          </Button>
          <Button
            onClick={() => setOpen(true)}
            id="id-searchImportInventory-btn-import">
            {getTranslateByKey('importInventory.import')}
          </Button>
        </S.AreaButton>

        <KogTabsComponent
          tabPanels={tabPanels}
          tabCurrent={tabCurrent}
          onChangeTab={newValue => changeTab(newValue)}
        />

        {/* Modals general */}

        {/* Modal result simple import with errors */}
        <KogModalFadeComponent
          open={openModalReturnImport}
          setOpen={setOpenModalReturnImport}>
          <ModalResultImport returnImport={dataReturnImport} />
        </KogModalFadeComponent>
      </S.Container>
    </ContainerScreen>
  );
}

function ImportInventoryLoaded() {
  return (
    <TabsInventoryProvider>
      <ImportInventoryScreen />
    </TabsInventoryProvider>
  );
}
export default ImportInventoryLoaded;
